<template>

<core-panel>

	<template v-slot:head>

		<h1>Ratings</h1>

		<p>All <b>{{ users.length }}</b> GeekGroup user ratings for this game.</p>

	</template>

	<template v-slot:body>

		<app-user v-for="u in users" :item="user(u.id)" :rating="u.rating" :notLinked="true" v-bind:key="u.id" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'ratings',
			users: []
		}

	},

	methods: {

		user: function(id) {

			return this.$store.getters['data/users/associated'][id]

		},

		response: function(json) {

			this.users = json.ratings.users

		}

	}

}

</script>
